/**
 * Lightweight logging shim. In development we emit to the console;
 * in production we swallow (or forward to your error tracker later).
 *
 * Every module that previously called `console.warn/error` should
 * `import { log } from "@/lib/logger"` instead.
 */
const isProd = process.env.NODE_ENV === "production";

function safe(method, args) {
  if (isProd) return;
  // eslint-disable-next-line no-console
  const fn = console[method];
  if (typeof fn === "function") fn(...args);
}

export const log = {
  warn: (...args) => safe("warn", args),
  error: (...args) => safe("error", args),
  info: (...args) => safe("info", args),
  debug: (...args) => safe("debug", args),
};

export default log;
